import {
  AppBar,
  Box,
  Button,
  Container,
  Toolbar,
  Typography,
  useMediaQuery,
  useScrollTrigger,
} from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import React from "react";
import {
  colorApp,
  colorBg,
  colorBlack,
  colorWhite,
  SvgComponent,
} from "../Resources/Design/theme";

import logoa from "../Resources/Design/logoa.png";
import logob from "../Resources/Design/logoc.png";

// Socials
import YouTubeIcon from "@mui/icons-material/YouTube";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import { Motion } from "./Motion";

/*import XIcon from "@mui/icons-material/X";
import PinterestIcon from "@mui/icons-material/Pinterest";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";*/

const iconSize = "24px";
const ytbIconSize = "33px";

const TikTokIcon = ({ color = colorApp, style = {}, icSize = iconSize }) => {
  return (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width={icSize}
      height={icSize}
    >
      <path d="M41,4H9C6.243,4,4,6.243,4,9v32c0,2.757,2.243,5,5,5h32c2.757,0,5-2.243,5-5V9C46,6.243,43.757,4,41,4z M37.006,22.323 c-0.227,0.021-0.457,0.035-0.69,0.035c-2.623,0-4.928-1.349-6.269-3.388c0,5.349,0,11.435,0,11.537c0,4.709-3.818,8.527-8.527,8.527 s-8.527-3.818-8.527-8.527s3.818-8.527,8.527-8.527c0.178,0,0.352,0.016,0.527,0.027v4.202c-0.175-0.021-0.347-0.053-0.527-0.053 c-2.404,0-4.352,1.948-4.352,4.352s1.948,4.352,4.352,4.352s4.527-1.894,4.527-4.298c0-0.095,0.042-19.594,0.042-19.594h4.016 c0.378,3.591,3.277,6.425,6.901,6.685V22.323z" />
    </svg>
  );
};

export const getSocials = (style = {}, iconProps = {}) => [
  /*{
    icon: <TikTokIcon style={style} {...iconProps} />,
    link: "",
    name: "TikTok",
  },*/
  {
    icon: <YouTubeIcon style={style} {...iconProps} />,
    link: "https://www.youtube.com/@%C4%8Dum%C3%A1knastop%C4%9B",
    sx: { width: ytbIconSize, height: ytbIconSize, maxHeight: ytbIconSize },
    name: "Youtube",
  },
  {
    icon: <InstagramIcon style={style} {...iconProps} />,
    link: "https://www.instagram.com/s_cumakem_na_stope",
    name: "Instagram",
  },
  {
    icon: <FacebookIcon style={style} {...iconProps} />,
    link: "https://www.facebook.com/profile.php?id=61571887757112",
    name: "Facebook",
  },
];

const height = "90px";
const socHeight = "40px";

export const shineAnimation = {
  WebkitMaskImage:
    "linear-gradient(45deg,#000 25%,rgba(0,0,0,.2) 50%,#000 75%)",
  maskImage: "linear-gradient(45deg,#000 25%,rgba(0,0,0,.2) 50%,#000 75%)",
  WebkitMaskSize: "800%",
  maskSize: "800%",
  WebkitMaskPosition: "0",
  maskPosition: "0",
  "&:hover": {
    transition: "mask-position 2s ease,-webkit-mask-position 2s ease",
    WebkitMaskPosition: "120%",
    maskPosition: "120%",
    opacity: "1",
  },
};

function Navbar({}) {
  const navigate = useNavigate();
  const location = useLocation();
  const [hovered, setHovered] = React.useState(null);
  const currentPath = location.pathname;
  const sm = useMediaQuery(`(max-width:1000px)`);

  const noDis = useMediaQuery(`(max-width:470px)`);

  const navigation = [
    { path: "/", name: "O nás", id: "aboutus" },
    {
      path: "/",
      name: "Spolupráce",
      id: "support",
      sx: { display: { xs: noDis ? "none" : "inline", sm: "inline" } },
    },
    { path: "/", name: "Kontakt", id: "contact" },
  ];

  // contact aboutus support
  const navScroll = (name, block = "center") => {
    if (location.pathname != "/") {
      navigate("/");
    }
    setTimeout(() => {
      const element = document.getElementById(name);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block });
      }
    }, 0);
  };

  const scroll = useScrollTrigger({
    target: window ? window : undefined,
    threshold: 0,
    disableHysteresis: true,
  });

  const animationTime = 2;

  const smallDisplay = sm || scroll;
  const bg = scroll
    ? `rgba(254, 249, 231, 0.9)`
    : sm
    ? colorBg
    : `rgba(254, 249, 231, 0)`;

  return (
    <header>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar
          elevation={scroll ? 2 : 0}
          position="fixed"
          sx={{
            //maxHeight: height,
            //height: height,
            backgroundColor: bg,
            ".MuiToolbar-root": {
              minHeight: height,
              maxHeight: height,
              height: height,
              px: "16px",
              maxWidth: 1200,
              width: "100%",
              mx: "auto",
              zIndex: 10,
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <Container maxWidth="lg" sx={{}}>
              <Box
                sx={{
                  height: scroll ? "0px" : socHeight,
                  width: "100%",
                  transition: `height .${animationTime}s ease-in-out`,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Box
                  sx={{
                    ml: "auto",
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",

                    height: "100%",
                  }}
                >
                  {getSocials().map((data, i) => (
                    <Motion key={`NavMot` + i}>
                      <Box sx={{ ml: "16px" }}>
                        <Box
                          component={"a"}
                          href={data.link}
                          target="_blank"
                          sx={{
                            opacity: scroll ? 0 : 1,
                            transition: `opacity .${animationTime}s ease-in-out`,
                            height: iconSize,
                            maxHeight: iconSize,
                            cursor: "pointer",

                            ...data.sx,
                          }}
                        >
                          <SvgComponent
                            svg={data.icon}
                            style={{
                              width: iconSize,
                              height: iconSize,
                              color: colorApp,
                              ...data.sx,
                            }}
                            sx={{
                              maxHeight: iconSize,
                              ...data.sx,
                            }}
                          />
                        </Box>
                      </Box>
                    </Motion>
                  ))}
                </Box>
              </Box>
            </Container>
            <Toolbar>
              <Box
                component={Link}
                href={"/"}
                sx={{
                  marginRight: "auto",
                  display: "flex",
                  alignItems: "center",
                  alignContent: "center",
                  justifyContent: "center",
                  textDecoration: "none",
                  p: "5px",
                  pl: "0px",
                  cursor: scroll ? "pointer" : "default",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  if (location.pathname != "/") {
                    navigate("/");
                  }
                  if (!scroll) {
                    return;
                  }
                  setTimeout(() => {
                    window.scrollTo({
                      top: 0,
                      behavior: "smooth",
                      block: "center",
                    });
                  }, 0);
                }}
              >
                <Box
                  component={"img"}
                  src={smallDisplay ? logob : logoa}
                  sx={{
                    marginTop: scroll ? "0px" : "-42px",
                    height: scroll ? "65px" : "100px",
                    width: scroll ? "65px" : "100px",
                    ...shineAnimation,
                    transition: `height .${animationTime}s ease-in-out,width .${animationTime}s ease-in-out, margin-top .${animationTime}s ease-in-out`,
                  }}
                />
              </Box>
              <Box
                sx={{
                  marginLeft: "auto",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                >
                  {navigation.map((data, index) => (
                    <Button
                      key={"ButtonNavbar" + index}
                      id={"ButtonNavbarId" + index}
                      name={`ButtonNavbarN${index}`}
                      sx={{
                        mr: "8px",
                        backgroundColor: "transparent",
                        "&:hover": { backgroundColor: "transparent" },
                        ...data?.sx,
                      }}
                      component={Link}
                      to={data.path}
                      tabIndex={index}
                      onClick={(e) => {
                        e.preventDefault();

                        navScroll(data.id);
                        setHovered(null);
                      }}
                      onMouseEnter={(e) => {
                        setHovered(e.target.name);
                      }}
                      onMouseLeave={(e) => {
                        if (e.target.name == hovered) {
                          setHovered(null);
                        }
                      }}
                      onContextMenu={(e) => {
                        setHovered(null);
                      }}
                    >
                      <Typography
                        variant="navbar"
                        sx={{
                          transform:
                            hovered == `ButtonNavbarN${index}`
                              ? "translateY(-2px)"
                              : "translateY(0px)",
                          transitionDuration: "200ms",
                          color: colorBlack,
                        }}
                      >
                        {data.name}
                      </Typography>
                    </Button>
                  ))}
                </Box>
              </Box>
            </Toolbar>
          </Box>
        </AppBar>
      </Box>
    </header>
  );
}

export default Navbar;
